import NotAccessible from "accountOwner/pages/ManagerDashboard/components/NotAccessible";
import { useAccountOwnerCommon } from "lib/Context/AccountOwner";

const NotAccessibleChatCheck = ({
  patientCheck = false,
  children,
  message,
  dontRenderAnyChildren = false,
  doctorChatCheck = false,
}) => {
  const {
    dataAccessValues,
    isOwner,
    isStaff,
    subscriptionValues: {
      isPatientConversationFeatureEnabled,
      isTeamConversationFeatureEnabled,
    },
    profile,
  } = useAccountOwnerCommon();
  if (doctorChatCheck) {
    return children;
  }
  let showNotAccessible = false;
  if (patientCheck) {
    const disablePatientChat = !isPatientConversationFeatureEnabled;
    showNotAccessible =
      (isOwner && disablePatientChat) ||
      (isStaff && (!dataAccessValues?.isPatientChat || disablePatientChat));
  } else {
    const disableTeamChat = !isTeamConversationFeatureEnabled;
    showNotAccessible =
      (isOwner && (!profile?.isMessenger || disableTeamChat)) ||
      (isStaff && (!dataAccessValues?.isMessenger || disableTeamChat));
  }
  if (showNotAccessible && dontRenderAnyChildren) return null;
  if (showNotAccessible) {
    return (
      <div className="not-accessible center_property h-100">
        <NotAccessible Message={message} />
      </div>
    );
  }

  return children;
};
export default NotAccessibleChatCheck;
